import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-36e61977"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "listDetailTop"
};
var _hoisted_2 = {
  key: 0,
  class: "artist"
};
var _hoisted_3 = {
  class: "top-left"
};
var _hoisted_4 = {
  class: "top-right",
  style: {
    "justify-content": "start"
  }
};
var _hoisted_5 = {
  class: "right-top"
};
var _hoisted_6 = {
  class: "right-description"
};
var _hoisted_7 = {
  class: "num-and-playc"
};
var _hoisted_8 = {
  class: "num"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "单曲数：", -1
  /* HOISTED */
  );
});

var _hoisted_10 = {
  class: "album"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "专辑数：", -1
  /* HOISTED */
  );
});

var _hoisted_12 = {
  class: "mv"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "MV数：", -1
  /* HOISTED */
  );
});

var _hoisted_14 = {
  class: "sheep-detail"
};
var _hoisted_15 = {
  class: "top-left"
};
var _hoisted_16 = {
  class: "top-right"
};
var _hoisted_17 = {
  class: "right-top"
};
var _hoisted_18 = {
  class: "right-name"
};
var _hoisted_19 = ["src"];
var _hoisted_20 = {
  class: "name"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-play1"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "播放全部", -1
  /* HOISTED */
  );
});

var _hoisted_23 = [_hoisted_21, _hoisted_22];
var _hoisted_24 = {
  class: "right-description"
};
var _hoisted_25 = {
  class: "right-tags"
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "标签：", -1
  /* HOISTED */
  );
});

var _hoisted_27 = ["onClick"];
var _hoisted_28 = {
  class: "slash"
};
var _hoisted_29 = {
  class: "num-and-playc"
};
var _hoisted_30 = {
  class: "num"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "歌曲数：", -1
  /* HOISTED */
  );
});

var _hoisted_32 = {
  class: "playc"
};

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "播放量：", -1
  /* HOISTED */
  );
});

var _hoisted_34 = {
  class: "description"
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "简介：", -1
  /* HOISTED */
  );
});

var _hoisted_36 = {
  key: 0,
  class: "aaa"
};
var _hoisted_37 = {
  key: 1
};
var _hoisted_38 = {
  class: "album-detail"
};
var _hoisted_39 = {
  class: "top-left"
};
var _hoisted_40 = {
  class: "top-right"
};
var _hoisted_41 = {
  class: "right-top"
};

var _hoisted_42 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "right-play"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-play1"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "播放全部")], -1
  /* HOISTED */
  );
});

var _hoisted_43 = {
  class: "right-description"
};
var _hoisted_44 = {
  class: "right-tags"
};

var _hoisted_45 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "歌手：", -1
  /* HOISTED */
  );
});

var _hoisted_46 = ["onClick"];

var _hoisted_47 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "slash"
  }, "/", -1
  /* HOISTED */
  );
});

var _hoisted_48 = {
  class: "num-and-playc"
};
var _hoisted_49 = {
  class: "num"
};

var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "创建时间：", -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  return Object.keys(_ctx.detailTopInfo).length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 歌手详情数据 "), _ctx.detailType == '歌手' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createCommentVNode(" 左边图片 "), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
    src: _ctx.detailTopInfo.cover,
    "preview-src-list": [_ctx.detailTopInfo.cover],
    alt: "点击查看图片"
  }, null, 8
  /* PROPS */
  , ["src", "preview-src-list"])]), _createCommentVNode(" 右边描述 "), _createElementVNode("div", _hoisted_4, [_createCommentVNode(" 歌手名 "), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.detailTopInfo.name), 1
  /* TEXT */
  ), _createCommentVNode(" 歌手描述信息 "), _createElementVNode("div", _hoisted_6, [_createCommentVNode(" 歌曲、专辑、mv "), _createElementVNode("div", _hoisted_7, [_createCommentVNode(" 歌曲数 "), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", null, _toDisplayString(_ctx.detailTopInfo.musicSize), 1
  /* TEXT */
  )]), _createCommentVNode(" 专辑量 "), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.detailTopInfo.albumSize), 1
  /* TEXT */
  )]), _createCommentVNode(" MV数 "), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(_ctx.detailTopInfo.mvSize), 1
  /* TEXT */
  )])])])])])) : _ctx.detailType == '歌单' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 歌单详情数据 "), _createElementVNode("div", _hoisted_14, [_createCommentVNode(" 左边图片 "), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_image, {
    src: _ctx.detailTopInfo.coverImgUrl,
    "preview-src-list": [_ctx.detailTopInfo.coverImgUrl],
    alt: "点击查看图片"
  }, null, 8
  /* PROPS */
  , ["src", "preview-src-list"])]), _createCommentVNode(" 右边描述 "), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.detailTopInfo.name), 1
  /* TEXT */
  ), _createCommentVNode(" 创建者名称和头像 "), _createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
    src: _ctx.detailTopInfo.creator.avatarUrl
  }, null, 8
  /* PROPS */
  , _hoisted_19), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.detailTopInfo.creator.nickname), 1
  /* TEXT */
  ), _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(_ctx.detailTopInfo.createTime, "YYYY-MM-DD")) + " 创建", 1
  /* TEXT */
  )]), _createCommentVNode(" 播放全部 "), _createElementVNode("div", {
    class: "right-play",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.handlePlaylist(_ctx.detailTopInfo.id);
    })
  }, _hoisted_23), _createCommentVNode(" 歌单描述信息 "), _createElementVNode("div", _hoisted_24, [_createCommentVNode(" 标签 "), _createElementVNode("div", _hoisted_25, [_hoisted_26, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailTopInfo.tags, function (tags, index) {
    return _openBlock(), _createElementBlock("span", {
      class: "tag-box",
      key: tags,
      onClick: function onClick($event) {
        return _ctx.tagClick(tags, _ctx.detailType);
      }
    }, [_createElementVNode("span", null, _toDisplayString(tags), 1
    /* TEXT */
    ), _withDirectives(_createElementVNode("span", _hoisted_28, "/", 512
    /* NEED_PATCH */
    ), [[_vShow, index !== _ctx.detailTopInfo.tags.length - 1]])], 8
    /* PROPS */
    , _hoisted_27);
  }), 128
  /* KEYED_FRAGMENT */
  )), _withDirectives(_createElementVNode("span", null, "暂无标签", 512
  /* NEED_PATCH */
  ), [[_vShow, !_ctx.detailTopInfo.tags.length]])]), _createCommentVNode(" 歌曲数和播放量 "), _createElementVNode("div", _hoisted_29, [_createCommentVNode(" 歌曲数 "), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("span", null, _toDisplayString(_ctx.detailTopInfo.trackCount), 1
  /* TEXT */
  )]), _createCommentVNode(" 播放量 "), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("span", null, _toDisplayString(_ctx.detailTopInfo.playCount), 1
  /* TEXT */
  )])]), _createCommentVNode(" 简介 "), _createElementVNode("span", _hoisted_34, [_hoisted_35, _ctx.detailTopInfo.description ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.detailTopInfo.description), 1
  /* TEXT */
  )) : (_openBlock(), _createElementBlock("span", _hoisted_37, "暂无简介"))])])])])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createCommentVNode(" 专辑详情数据 "), _createElementVNode("div", _hoisted_38, [_createCommentVNode(" 左边图片 "), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_image, {
    src: _ctx.detailTopInfo.picUrl,
    "preview-src-list": [_ctx.detailTopInfo.picUrl],
    alt: "点击查看图片"
  }, null, 8
  /* PROPS */
  , ["src", "preview-src-list"])]), _createCommentVNode(" 右边描述 "), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.detailTopInfo.name), 1
  /* TEXT */
  ), _createCommentVNode(" 播放全部 "), _hoisted_42, _createCommentVNode(" 歌单描述信息 "), _createElementVNode("div", _hoisted_43, [_createCommentVNode(" 标签 "), _createElementVNode("div", _hoisted_44, [_hoisted_45, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailTopInfo.artists, function (songer) {
    return _openBlock(), _createElementBlock("span", {
      class: "tag-box",
      key: songer.id,
      onClick: function onClick($event) {
        return _ctx.tagClick(songer.id, _ctx.detailType);
      }
    }, [_createElementVNode("span", null, _toDisplayString(songer.name), 1
    /* TEXT */
    ), _hoisted_47], 8
    /* PROPS */
    , _hoisted_46);
  }), 128
  /* KEYED_FRAGMENT */
  ))]), _createCommentVNode(" 歌曲数和播放量 "), _createElementVNode("div", _hoisted_48, [_createCommentVNode(" 歌曲数 "), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(_ctx.detailTopInfo.publishTime, "YYYY-MM-DD")), 1
  /* TEXT */
  )])])])])])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  ))])) : _createCommentVNode("v-if", true);
}